import React from 'react';
import { Link, useParams } from 'react-router-dom';

function EnergyOfficialsBreadCrumb() {
   const {id, plantName} = useParams();
    // Convert slug (with -) back to spaces
    const decodedPlantName = plantName.replace(/-/g, ' ');
  return (
    <div className="breadcrumb-wrapper py-3 px-3">
      <div className="container">
        <h2 className="breadcrumb-title">{decodedPlantName}</h2>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb custom-breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to={`/renewableenergydashboard/${(plantName).replace(/\s+/g, "-")}/${id}`} className="breadcrumb-link">Renewable Energy Dashboard</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
            Renewable Energy Plant Officials
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
}

export default EnergyOfficialsBreadCrumb;
